var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 138,
    viewBox: "0 0 120 138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "empty-box_11696724",
    transform: "translate(-8 -3.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13110",
    "data-name": "Path 13110",
    d: "M62,45.714v64.07L12,90.07V26Z",
    transform: "translate(6 32.215)",
    fill: "#bf9ee9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13111",
    "data-name": "Path 13111",
    d: "M68,45.714,58,58.035,18,42.264,8,38.321,18,26Z",
    transform: "translate(0 32.215)",
    fill: "#e7d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13112",
    "data-name": "Path 13112",
    d: "M82,26V90.07L32,109.784V45.714Z",
    transform: "translate(36 32.215)",
    fill: "#d5b4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13113",
    "data-name": "Path 13113",
    d: "M112,37.714,62,57.428,12,37.714,62,18Z",
    transform: "translate(6 20.501)",
    fill: "#8d76ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13114",
    "data-name": "Path 13114",
    d: "M92,38.321,82,42.264,42,58.035,32,45.714,82,26Z",
    transform: "translate(36 32.215)",
    fill: "#e7d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13115",
    "data-name": "Path 13115",
    d: "M36.71,14.524v-3.1c0-6.6-7-9.906-11.1-5.224l-6.75,7.688",
    transform: "translate(16.29 0)",
    fill: "#ffb6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13116",
    "data-name": "Path 13116",
    d: "M36.71,11.73v3.1c0,6.6-7,9.906-11.1,5.224l-6.75-7.688",
    transform: "translate(16.29 11.32)",
    fill: "#ffb6a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3183",
    "data-name": "Rectangle 3183",
    width: 9.857,
    height: 25,
    rx: 4.928,
    transform: "translate(30.5 23.715) rotate(-90)",
    fill: "#e76445"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13810",
    "data-name": "Group 13810",
    transform: "translate(65.175 16.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13117",
    "data-name": "Path 13117",
    d: "M34.62,13.928H33.37A2.464,2.464,0,1,1,33.37,9h1.25a2.464,2.464,0,1,1,0,4.928Z",
    transform: "translate(-30.87 -9)",
    fill: "#d3dce5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13118",
    "data-name": "Path 13118",
    d: "M34.268,43.46a2.517,2.517,0,0,1-1.175-.3,2.436,2.436,0,0,1-1.025-3.327,21.13,21.13,0,0,1,1.55-2.44,2.537,2.537,0,0,1,3.5-.542,2.454,2.454,0,0,1,.55,3.45,17.835,17.835,0,0,0-1.175,1.848,2.5,2.5,0,0,1-2.2,1.306Zm9.375-8.354a2.47,2.47,0,0,1-.95-4.756,22.439,22.439,0,0,1,2.75-.912,2.509,2.509,0,0,1,3.05,1.75,2.466,2.466,0,0,1-1.775,3.006,16.543,16.543,0,0,0-2.125.715,2.519,2.519,0,0,1-.95.2Zm12.7-1.528a2.509,2.509,0,0,1-2.475-2.095,2.477,2.477,0,0,1,2.1-2.809,8.277,8.277,0,0,0,1.85-.517,2.518,2.518,0,0,1,3.3,1.281,2.454,2.454,0,0,1-1.3,3.253,13.5,13.5,0,0,1-3.1.887c-.125,0-.25.025-.375.025Zm8.425-8.428h-.325a2.458,2.458,0,0,1-2.15-2.76,6.627,6.627,0,0,0,.075-1.01,5.138,5.138,0,0,0-.05-.887,2.493,2.493,0,0,1,4.95-.591,14.69,14.69,0,0,1,.1,1.5c0,.567-.05,1.109-.1,1.651A2.511,2.511,0,0,1,64.793,25.2ZM58.943,14.8a2.475,2.475,0,0,1-1.025-.222,7.63,7.63,0,0,0-1.85-.542,2.462,2.462,0,1,1,.825-4.855,11.947,11.947,0,0,1,3.075.912,2.448,2.448,0,0,1,1.25,3.253A2.509,2.509,0,0,1,58.943,14.8Zm-12.75-.862H43.618a2.464,2.464,0,1,1,0-4.928h2.575a2.464,2.464,0,1,1,0,4.928Z",
    transform: "translate(-29.518 -8.985)",
    fill: "#d3dce5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13119",
    "data-name": "Path 13119",
    d: "M33.37,31.161a2.49,2.49,0,0,1-2.5-2.464V27.464a2.5,2.5,0,0,1,5,0V28.7A2.49,2.49,0,0,1,33.37,31.161Z",
    transform: "translate(-30.87 14.428)",
    fill: "#d3dce5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/empty-box.92cd4463f52f631a9eb6a0c0fba7a289.svg";
export { ForwardRef as ReactComponent };